export enum ContactMethod {
  address = 'ADDRESS',
  email = 'EMAIL',
  phone = 'PHONE',
  pager = 'PAGER',
  fax = 'FAX',
  cellPhone = 'CELL_PHONE',
  instantMessage = 'INSTANT_MESSAGE',
  sms = 'SMS',
  help = 'HELP'
}
